import React from 'react';
import { trans } from '../utils';

/**
 * Typing Indicator - Shows when assistant is typing
 */
const TypingIndicator = () => {
  return (
    <div className="chat-typing-indicator" role="status" aria-label={trans('Assistant is typing')}>
      <span className="chat-typing-dot"></span>
      <span className="chat-typing-dot"></span>
      <span className="chat-typing-dot"></span>
    </div>
  );
};

export default TypingIndicator;
